import * as React from 'react';
import { useLazyQuery } from '@grandvisionhq/graphql';
import GET_SHOPPING_LIST_BY_ID from '../operations/queries/get-shopping-list-by-id.js';
import { mapShoppingListToWishlistItems } from '../utils/shopping-list-to-wishlist-mapper.js';

const useShoppingListById = (localShoppingListId)=>{
    var ref, ref1;
    const [isLoading, setIsLoading] = React.useState(true);
    const [trigger, { data , error  }] = useLazyQuery(GET_SHOPPING_LIST_BY_ID, {
        context: {
            // TODO: Make use of the locale property from useIntl once BE supports this.
            // For now We need to pass this with a hardcoded value of 'en', because the BE is unable to handle values like en-GB.
            // https://jira.grandvision.global/browse/MACC-15068
            forwardHeaders: {
                'Accept-Language': 'en'
            }
        },
        onCompleted: ()=>{
            setIsLoading(false);
        },
        onError: ()=>{
            setIsLoading(false);
        }
    });
    React.useEffect(()=>{
        if (localShoppingListId) {
            trigger({
                variables: {
                    shoppinglistId: localShoppingListId
                }
            });
        } else {
            setIsLoading(false);
        }
    }, [
        trigger,
        localShoppingListId
    ]);
    var ref2, ref3;
    return {
        data: (data === null || data === void 0 ? void 0 : data.shoppinglistById.shoppinglist) ? {
            items: mapShoppingListToWishlistItems(data === null || data === void 0 ? void 0 : data.shoppinglistById.shoppinglist),
            id: (ref2 = (ref = data === null || data === void 0 ? void 0 : data.shoppinglistById.shoppinglist) === null || ref === void 0 ? void 0 : ref.id) !== null && ref2 !== void 0 ? ref2 : ''
        } : null,
        loading: isLoading,
        error: (ref3 = error !== null && error !== void 0 ? error : data === null || data === void 0 ? void 0 : (ref1 = data.shoppinglistById) === null || ref1 === void 0 ? void 0 : ref1.failure) !== null && ref3 !== void 0 ? ref3 : null
    };
};

export { useShoppingListById };
//# sourceMappingURL=use-shopping-list-by-id.js.map
